import { render, staticRenderFns } from "./CombInputForm.vue?vue&type=template&id=9478ef4e&scoped=true&"
import script from "./CombInputForm.vue?vue&type=script&lang=js&"
export * from "./CombInputForm.vue?vue&type=script&lang=js&"
import style0 from "./CombInputForm.vue?vue&type=style&index=0&id=9478ef4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9478ef4e",
  null
  
)

export default component.exports